import React from "react";

const FAQ = () => {
  return (
    <div className="m-5">
      <section className=" dark:bg-gray-800 dark:text-gray-100 h-screen">
        <div className="container flex flex-col justify-center p-4 mx-auto md:p-8">
          <h2 className="mb-12 text-4xl font-bold leading-none text-center sm:text-5xl">
            Frequently Asked Questions
          </h2>
          <div className="flex flex-col divide-y sm:px-8 lg:px-12 xl:px-32 divide-gray-700">
            <details>
              <summary className="py-2 outline-none cursor-pointer focus:underline">
                Why CS Mentor Course?
              </summary>
              <div className="px-4 pb-4">
                <p>
                  CS Mentor will explain cs related course with easy and
                  simplest way.
                </p>
              </div>
            </details>
            <details>
              <summary className="py-2 outline-none cursor-pointer focus:underline">
                About the instructor?
              </summary>
              <div className="px-4 pb-4">
                <p>
                  Our instructor have a wide range of knowledge about cs
                  programming courses. You will get best output by enrolling our
                  courses. Our teaching methods are beginner friendly.
                </p>
              </div>
            </details>
            <details>
              <summary className="py-2 outline-none cursor-pointer focus:underline">
                Why choose CS Mentor?
              </summary>
              <div className="px-4 pb-4 space-y-2">
                <p>You will get our all facilities by joining our courses.</p>
              </div>
            </details>
          </div>
        </div>
      </section>
    </div>
    // <section className="bg-gray-800 text-gray-100">
    //   <div className="container flex flex-col justify-center p-4 mx-auto md:p-8">
    //     <p className="p-2 text-sm font-medium tracking-wider text-center uppercase">
    //       How it works
    //     </p>
    //     <h2 className="mb-12 text-4xl font-bold leading-none text-center sm:text-5xl">
    //       Frequently Asked Questions
    //     </h2>
    //     <div className="flex flex-col divide-y sm:px-8 lg:px-12 xl:px-32 divide-gray-700">
    //       <details>
    //         <summary className="py-2 outline-none cursor-pointer focus:underline">
    //           Optio maiores eligendi molestiae totam dolores similique?
    //         </summary>
    //         <div className="px-4 pb-4">
    //           <p>
    //             Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde
    //             neque in fugiat magni, quas animi enim veritatis deleniti ex.
    //             Impedit.
    //           </p>
    //         </div>
    //       </details>
    //       <details>
    //         <summary className="py-2 outline-none cursor-pointer focus:underline">
    //           Modi dolorem veritatis culpa quos consequuntur beatae itaque
    //           excepturi perspiciatis?
    //         </summary>
    //         <div className="px-4 pb-4">
    //           <p>
    //             Lorem ipsum dolor sit amet consectetur adipisicing elit. Est
    //             aspernatur quae, eos explicabo odit minima libero veniam
    //             similique quibusdam doloribus facilis ipsa accusantium vel
    //             maiores corrupti! Libero voluptate a doloribus?
    //           </p>
    //         </div>
    //       </details>
    //       <details>
    //         <summary className="py-2 outline-none cursor-pointer focus:underline">
    //           Magni reprehenderit possimus debitis?
    //         </summary>
    //         <div className="px-4 pb-4 space-y-2">
    //           <p>
    //             Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
    //             voluptates aspernatur dolores in consequatur doloremque
    //             inventore reprehenderit, consequuntur perspiciatis architecto.
    //           </p>
    //           <p>
    //             Sed consectetur quod tenetur! Voluptatibus culpa incidunt
    //             veritatis velit quasi cupiditate unde eaque! Iure, voluptatibus
    //             autem eaque unde possimus quae.
    //           </p>
    //         </div>
    //       </details>
    //     </div>
    //   </div>
    // </section>
  );
};

export default FAQ;
